import type { HttpResponse } from "~/utils/httpClient";

const valueType = (value: unknown) =>
  value === null ? "null" : Array.isArray(value) ? "array" : typeof value;

/** Only bounded metadata is retained, never the response or request objects. */
export const getApiResponseDiagnostics = (response: HttpResponse<unknown>) => {
  const body = response.data;
  const hasData = typeof body === "object" && body !== null && "data" in body;
  const header: unknown = response.headers?.["content-type"];
  const mime =
    typeof header === "string"
      ? header.split(";")[0]?.trim().toLowerCase()
      : undefined;
  let endpoint = "other";
  try {
    const path = new URL(response.url ?? "/", window.location.origin).pathname;
    if (/^\/(auth\/session|users|businesses)$/.test(path)) endpoint = path;
    else if (/^\/businesses\/\d+$/.test(path)) endpoint = "/businesses/:id";
    else if (/^\/users\/\d+$/.test(path)) endpoint = "/users/:id";
  } catch {
    // An unavailable URL should not hide the response-shape evidence.
  }
  return {
    status:
      Number.isInteger(response.status) &&
      response.status >= 100 &&
      response.status <= 599
        ? response.status
        : undefined,
    endpoint,
    contentType:
      mime === "application/json" ||
      mime === "text/html" ||
      mime === "text/plain"
        ? mime
        : mime
          ? "other"
          : "missing",
    bodyType: valueType(body),
    hasData,
    dataType: hasData ? valueType(body.data) : "absent",
  };
};

export class InvalidApiResponseError extends Error {
  readonly diagnostics: ReturnType<typeof getApiResponseDiagnostics>;

  constructor(response: HttpResponse<unknown>) {
    super("Couldn't find data");
    this.diagnostics = getApiResponseDiagnostics(response);
  }
}
